"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PackageHeader = void 0;
var react_1 = __importDefault(require("react"));
var filesize_1 = __importDefault(require("filesize"));
var moment_1 = __importDefault(require("moment"));
require("./PackageHeader.scss");
var PackageExpiration_1 = require("@app/components/packages/PackageExpiration");
var constants_1 = require("@app/shared/constants");
var PackageHeader = function (props) { return (react_1.default.createElement("nav", { className: "package-header" },
    react_1.default.createElement("div", { className: "level is-mobile" },
        react_1.default.createElement("div", { className: "level-left" },
            react_1.default.createElement("div", { className: "level-item" },
                react_1.default.createElement("a", { onClick: props.onGoBack },
                    react_1.default.createElement("span", { className: "icon is-large" },
                        react_1.default.createElement("i", { className: "fas fa-chevron-circle-left fa-2x" })))),
            react_1.default.createElement("div", { className: "level-item is-hidden-mobile" }, props.package.title)),
        react_1.default.createElement("div", { className: "level-item" },
            react_1.default.createElement("div", null,
                react_1.default.createElement("p", { className: "heading" }, "Received"),
                react_1.default.createElement("p", null,
                    react_1.default.createElement("span", { className: "tooltip is-tooltip-bottom", "data-tooltip": moment_1.default(props.package.creationDate).format(constants_1.DATE_TIME_FORMAT) }, moment_1.default(props.package.creationDate).format(constants_1.DATE_FORMAT))))),
        react_1.default.createElement("div", { className: "level-item" },
            react_1.default.createElement("div", null,
                react_1.default.createElement("p", { className: "heading" }, "Size"),
                react_1.default.createElement("p", null, filesize_1.default(props.package.totalBytes)))),
        react_1.default.createElement("div", { className: "level-item" },
            react_1.default.createElement("div", null,
                react_1.default.createElement("p", { className: "heading" }, "Expires in"),
                react_1.default.createElement(PackageExpiration_1.PackageExpiration, { expirationDate: (props.package.expirationDate === null) ? '' : props.package.expirationDate, displayIcon: false }))),
        react_1.default.createElement("div", { className: "level-right" }, props.deletePackageVisible &&
            react_1.default.createElement("div", { className: "level-item" },
                react_1.default.createElement("a", { onClick: props.onDeletePackage },
                    react_1.default.createElement("span", { className: "icon" },
                        react_1.default.createElement("i", { className: "fas fa-trash fa-lg" })))))))); };
exports.PackageHeader = PackageHeader;
